module.exports = __webpack_public_path__ + "static/media/NS-LOGO.a49daaac.png";